<template>
  <b-dropdown
    class="dropdown-status-column"
    :triggers="['hover']"
    aria-role="list"
    position="is-bottom-left"
  >
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <template #trigger>
      <b-button
        :class="
          access.status === 'new' || access.status === undefined
            ? 'is-primary'
            : access.status === 'analyse'
            ? 'is-info'
            : access.status === 'deviation'
            ? 'is-warning'
            : access.status === 'recovered'
            ? 'is-recovered'
            : access.status === 'ok'
            ? 'is-success'
            : access.status === 'loss'
            ? 'is-danger'
            : 'is-primary'
        "
        slot="trigger"
        @click.stop
      >
        {{
          access.status === "new" || access.status === undefined
            ? $t("accesses.statusNew")
            : access.status == "analyse"
            ? $t("accesses.statusAnalyse")
            : access.status == "deviation"
            ? $t("accesses.statusDeviation")
            : access.status == "ok"
            ? $t("accesses.statusOk")
            : access.status == "recovered"
            ? $t("accesses.statusRecovered")
            : access.status == "loss"
            ? $t("accesses.statusLoss")
            : $t("accesses.statusNew")
        }}
      </b-button>
    </template>

    <div v-if="permissions.changeAccessStatus">
      <b-dropdown-item
        aria-role="listitem"
        v-if="access.status !== 'new' && access.status !== undefined"
      >
        <button
          class="button is-fullwidth"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          @click.stop="changeAccessStatus(access, 'new')"
        >
          {{ $t("accesses.statusNew") }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="access.status !== 'analyse'">
        <button
          class="button is-info is-fullwidth"
          @click.stop="changeAccessStatus(access, 'analyse')"
        >
          {{ $t("accesses.statusAnalyse") }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="access.status !== 'deviation'"
      >
        <button
          class="button is-warning is-fullwidth"
          @click.stop="changeAccessStatus(access, 'deviation')"
        >
          {{ $t("accesses.statusDeviation") }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="access.status !== 'ok'">
        <button
          class="button is-success is-fullwidth"
          @click.stop="changeAccessStatus(access, 'ok')"
        >
          {{ $t("accesses.statusOk") }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="access.status !== 'recovered'"
      >
        <button
          class="button is-recovered is-fullwidth"
          @click.stop="changeAccessStatus(access, 'recovered')"
        >
          {{ $t("accesses.statusRecovered") }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="access.status !== 'loss'">
        <button
          class="button is-danger is-fullwidth"
          @click.stop="changeAccessStatus(access, 'loss')"
        >
          {{ $t("accesses.statusLoss") }}
        </button>
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";

export default {
  props: ["access"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    changeAccessStatus(tableRow, status) {
      this.isLoading = true;
      this.$store
        .dispatch("changeAccessStatus", {
          accessId: tableRow._id,
          status
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$forceUpdate();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
.is-recovered {
  background-color: #36b17a;
}
.button {
  width: 150px;
}
</style>
